import { render, staticRenderFns } from "./visa.vue?vue&type=template&id=0995ae82&scoped=true"
import script from "./visa.vue?vue&type=script&lang=js"
export * from "./visa.vue?vue&type=script&lang=js"
import style0 from "./visa.vue?vue&type=style&index=0&id=0995ae82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0995ae82",
  null
  
)

export default component.exports